/* Home V2: the turn — "before AI → after AI" four-stage sequence.
   The figure/choreography (var TURN) is ported from the Rev 9 reference
   (People Equation Rev 9); clamp01/remap/smooth/lerp come from PEHomeV2.utils
   and the reduced-motion flag from PEHomeV2.reduce. The copy lives in PARTS
   here, exactly as the reference carries it — hardcoded, not CMS-driven.

   The interaction, however, is NOT the reference's continuous scroll-scrub.
   The section is one viewport tall and its four settled stages (conditions →
   pyramid → decomposition → recomposition) are advanced by three discrete
   scroll / tap / arrow-key steps, tweening between fixed points on the TURN
   timeline so all the motion happens in-between (see "the stepper" below).
   The component does not register with PEHomeV2's scroll loop. */
(function () {
  'use strict';
  if (!window.PEHomeV2) { return; }

  var root = document.getElementById('pe-turn');
  if (!root) { return; }

  function $(sel, r) { return (r || root).querySelector(sel); }
  function $$(sel, r) { return Array.prototype.slice.call((r || root).querySelectorAll(sel)); }

  if (!$('#turnViz')) { return; }

  var utils = window.PEHomeV2.utils;
  var clamp01 = utils.clamp01, remap = utils.remap, smooth = utils.smooth, lerp = utils.lerp;
  var reduce = !!window.PEHomeV2.reduce;

  var TURN = (function () {
    var NS  = 'http://www.w3.org/2000/svg';
    var viz = $('#turnViz');
    if (!viz) { return null; }

    var CY = 214;
    /* half-width of each stage at full size. the conditions panel is the only
       one that changes shape, going from a wide row to a narrow column. */
    var HW = [236, 236, 236, 200], HW_COL = 78;
    var SLOT, OFFSTAGE, SUMMARY;
    var CAPS  = $$('.cap');
    var LONG  = ['FOUR CONDITIONS', 'PYRAMID', 'DECOMPOSITION', 'RECOMPOSITION'];
    var SHORT = ['CONDITIONS', 'PYRAMID', 'TASKS', 'RE-FORM'];

    /* On a wide screen the whole strip fits and every stage stays legible. On a
       phone the camera follows the active panel instead and the finished stages
       run off the left edge. Same strip, tighter lens. */
    function lens() {
      var narrow = window.innerWidth < 900;
      viz.setAttribute('viewBox', narrow ? '0 0 700 460' : '0 0 1280 460');
      SLOT = narrow
        ? [ { x: 434, s: 0.86 }, { x: 152, s: 0.26 }, { x: 46, s: 0.20 }, { x: -26, s: 0.17 } ]
        : [ { x: 890, s: 1.00 }, { x: 480, s: 0.38 }, { x: 250, s: 0.30 }, { x:  70, s: 0.26 } ];
      OFFSTAGE = narrow ? 880 : 1420;
      /* the final hold: all four at ONE scale, evenly pitched. */
      var pitch = narrow ? 152 : 300, x0 = narrow ? 122 : 190, sc = narrow ? 0.21 : 0.36;
      SUMMARY = [0, 1, 2, 3].map(function (i) { return { x: x0 + pitch * i, s: sc }; });
      for (var c = 0; c < CAPS.length; c++) { CAPS[c].textContent = narrow ? SHORT[c] : LONG[c]; }
      return narrow;
    }
    var NARROW = lens();

    /* ── one body of work, in three arrangements ── */
    var LAY = [1, 3, 5, 7], L = LAY.length;
    var APEX = -142, BASE = 122, HALF = 220;
    var ROWS = [-96, -32, 32, 96];
    var seed = 20260805;
    function rnd() { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; }

    var defs = [], idx = 0;
    for (var i = 0; i < L; i++) {
      var ly = APEX + (BASE - APEX) * ((i + 0.6) / L);
      var lw = HALF * ((i + 0.6) / L), n = LAY[i];
      for (var k = 0; k < n; k++, idx++) {
        defs.push({ px: -lw + 2 * lw * ((k + 0.5) / n), py: ly, layer: i });
      }
    }
    defs.forEach(function (d, q) {
      d.human = rnd() < 0.38;                        /* a third stay with a person */
      d.rx = -186 + 124 * Math.floor(q / 4);
      d.ry = ROWS[q % 4];
      var u = rnd(), h = 0.5 + (u < 0.5 ? -1 : 1) * Math.pow(Math.abs(2 * u - 1), 0.62) / 2;
      var waist = Math.pow(Math.abs(2 * h - 1), 1.35);
      d.ey = -134 + 268 * h;
      d.ex = (rnd() * 2 - 1) * (34 + 108 * waist);
    });

    /* stage 02 rules */
    var rulesG = $('#pyrRules');
    for (var r = 1; r < L; r++) {
      var ry = APEX + (BASE - APEX) * (r / L), rw = HALF * (r / L);
      var ln = document.createElementNS(NS, 'line');
      ln.setAttribute('x1', -rw); ln.setAttribute('x2', rw);
      ln.setAttribute('y1', ry);  ln.setAttribute('y2', ry);
      rulesG.appendChild(ln);
    }

    var S = 11, HS = S / 2;
    var SLATE = [116, 146, 148], HUMAN = [238, 120, 78], AGENT = [74, 184, 191];
    function mixc(a, b, m) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * m); }); }
    function rgb(c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }

    function el(tag, attrs) {
      var e = document.createElementNS(NS, tag);
      for (var k in attrs) { e.setAttribute(k, attrs[k]); }
      return e;
    }
    /* a person: stick figure. an agent: a line-drawn machine. */
    function icon(human) {
      var g = el('g', { 'class': 'ico ' + (human ? 'ico-h' : 'ico-a') });
      if (human) {
        g.appendChild(el('circle', { cx: 0, cy: -9, r: 3.8 }));
        g.appendChild(el('path', { d: 'M0 -5.2 L0 4 M-6 -1.4 L6 -1.4 M0 4 L-5 11.6 M0 4 L5 11.6' }));
      } else {
        g.appendChild(el('rect', { x: -8, y: -9.5, width: 16, height: 13, rx: 3 }));
        g.appendChild(el('path', { d: 'M0 -13.5 L0 -9.5 M-8 0.5 L-11.5 0.5 M8 0.5 L11.5 0.5 M-4.5 3.5 L-4.5 9 M4.5 3.5 L4.5 9 M-6.5 11.5 L6.5 11.5' }));
        g.appendChild(el('circle', { 'class': 'ico-eye', cx: -3.2, cy: -3.4, r: 1.4 }));
        g.appendChild(el('circle', { 'class': 'ico-eye', cx: 3.2, cy: -3.4, r: 1.4 }));
        g.appendChild(el('circle', { 'class': 'ico-eye', cx: 0, cy: -13.5, r: 1.6 }));
      }
      return g;
    }
    function markGroup(d) {
      var g = el('g', {});
      g._dot = el('circle', { 'class': 'mk-dot', r: HS, fill: rgb(SLATE) });
      g._ico = icon(d.human);
      g.appendChild(g._dot); g.appendChild(g._ico);
      return g;
    }

    var pyrG = $('#pyrMarks'), decG = $('#decMarks'), recG = $('#recMarks');
    defs.forEach(function (d) {
      /* before AI, every task in the pyramid is held by a person. */
      var ph = icon(true);
      ph.setAttribute('class', 'ico ico-p');
      ph.setAttribute('transform', 'translate(' + d.px.toFixed(1) + ',' + d.py.toFixed(1) + ') scale(.76)');
      pyrG.appendChild(ph);
      d.dec = markGroup(d); decG.appendChild(d.dec);
      d.rec = markGroup(d); recG.appendChild(d.rec);
    });
    /* kind runs 0 to 1 as a task settles: the dot fades out, the icon fades in */
    function place(g, d, x, y, kind) {
      g.setAttribute('transform', 'translate(' + x.toFixed(1) + ',' + y.toFixed(1) + ')');
      g._dot.style.opacity = (1 - kind).toFixed(3);
      g._dot.setAttribute('fill', rgb(mixc(SLATE, d.human ? HUMAN : AGENT, kind)));
      g._ico.style.opacity = kind.toFixed(3);
    }

    /* ── the copy ── */
    var PARTS = [
      { at: 0.00, glow: 'rgba(234,243,244,.08)', num: '01', chap: 'Before AI',
        head: 'Enterprises have always had to solve four things',
        body: '<p>Judgement and intelligence were scarce and therefore expensive. Coordination was critical and difficult to do at scale.</p>' },

      { at: 0.24, glow: 'rgba(42,134,140,.16)', num: '02', chap: 'Before AI',
        head: 'The pyramid was the outcome',
        body: '<p class="tight">How a firm arranged itself was an answer to those conditions, not a matter of choice.</p>'
           + '<p class="say">Not a preference. An outcome.</p>' },

      { at: 0.48, glow: 'rgba(74,184,191,.18)', num: '03', chap: 'After AI',
        head: 'AI impacted three of the conditions',
        body: '<p class="tight">Coordination simply got cheaper. Knowledge and intelligence became abundant. Judgement remained scarce and expensive.</p>'
           + '<p>The work comes apart task by task: some a person keeps, some an agent takes.</p>'
           + '<p class="say">The conditions changed.</p>' },

      { at: 0.72, glow: 'rgba(238,120,78,.18)', num: '04', chap: 'After AI',
        head: 'The organisation re-forms',
        body: '<p class="tight">The two conditions that produced the pyramid have come apart. That is why the shape changes.</p>'
           + '<p class="say">Roles don’t automate. Tasks do.</p>'
           + '<p>Judgement is needed throughout the work now, not only at the top. An hourglass, an inverted pyramid, or something else entirely: the shape follows the work, so we do not get to know it in advance.</p>' }
    ];

    var beatEls = $$('.turn-beat', $('#turnRead'));
    var face = 0, beat = -1;
    var stage = $('#turnStage'), fill = $('#chaplineFill'), stops = $$('.chapline-stops li');

    function setBeat(n) {
      if (n === beat) { return; }
      beat = n;
      var b = PARTS[n];
      var into = beatEls[1 - face], out = beatEls[face];
      $('.num', into).textContent = b.num;
      $('.num', into).nextElementSibling.textContent = b.chap;
      $('h2', into).textContent = b.head;
      $('.lede', into).innerHTML = b.body;
      into.classList.remove('is-out'); into.removeAttribute('aria-hidden');
      out.classList.add('is-out');     out.setAttribute('aria-hidden', 'true');
      face = 1 - face;
      stage.style.setProperty('--stageglow', b.glow);
      for (var q = 0; q < stops.length; q++) {
        stops[q].classList.toggle('is-on',   q === n);
        stops[q].classList.toggle('is-past', q <  n);
      }
    }

    var E = {
      stgs: $$('.stg'), caps: CAPS, joins: $$('.join'),
      c4: $$('.c4'), era: $('#era'), eraLab: $('#eraLab'), legend: $('#legend')
    };
    E.c4o = E.c4.map(function (g) { return $('.c4-o', g); });
    E.c4h = E.c4.map(function (g) { return $('.c4-lab-h', g); });
    E.c4v = E.c4.map(function (g) { return $('.c4-lab-v', g); });
    var ROW_X = [-190, -63, 63, 190], COL_Y = [-108, -36, 36, 108];

    /* v runs 0 to 1 as the four conditions leave their row and stack into a
       column on the left. the circle shrinks and the labels swap sides. */
    function conditions(v) {
      for (var i = 0; i < 4; i++) {
        E.c4[i].setAttribute('transform',
          'translate(' + lerp(ROW_X[i], 0, v).toFixed(1) + ',' + lerp(0, COL_Y[i], v).toFixed(1) + ')');
        E.c4o[i].setAttribute('cx', lerp(0, -52, v).toFixed(1));
        E.c4o[i].setAttribute('cy', lerp(-24, 0, v).toFixed(1));
        E.c4o[i].setAttribute('r',  lerp(46, 22, v).toFixed(1));
        E.c4h[i].style.opacity = clamp01(1 - v * 2.4).toFixed(3);
        E.c4v[i].style.opacity = clamp01((v - 0.55) * 2.4).toFixed(3);
      }
    }
    var BEFORE = ['Expensive', 'Scarce', 'Limited', 'Hard to scale'];
    var AFTER  = ['Expensive', 'Abundant', 'Abundant', 'Cheap'];
    var last = -1, isAfter = false, moved = [0, 0, 0, 0];

    /* THE FINAL HOLD — once the reader reaches the end and stops, wait, then
       draw the four stages onto one line at one scale. Runs on its own clock;
       any scroll cancels it and puts the strip back. */
    var holdK = 0, holdWait = null, holdRAF = null, seenT = 0;
    function holdCancel() {
      if (holdWait) { clearTimeout(holdWait); holdWait = null; }
      if (holdRAF) { cancelAnimationFrame(holdRAF); holdRAF = null; }
      if (holdK !== 0) { holdK = 0; last = -1; paint(seenT); }
    }
    function holdArm(t) {
      if (t < 0.94 || reduce) { return; }
      if (holdWait || holdK > 0) { return; }
      holdWait = setTimeout(function () {
        holdWait = null;
        var t0 = performance.now();
        (function step(now) {
          holdK = smooth(clamp01((now - t0) / 1100));
          last = -1; paint(seenT);
          if (holdK < 1) { holdRAF = requestAnimationFrame(step); } else { holdRAF = null; }
        })(t0);
      }, 3500);
    }

    function slotAt(age) {
      if (age <= 0) { return SLOT[0]; }
      var i = Math.min(SLOT.length - 2, Math.floor(age)), f = clamp01(age - i);
      var A = SLOT[i], B = SLOT[i + 1];
      return { x: lerp(A.x, B.x, f), s: lerp(A.s, B.s, f) };
    }

    function paint(t) {
      if (Math.abs(t - seenT) > 0.002) {        /* the reader moved: put it back */
        seenT = t;
        if (holdK > 0 || holdWait) { holdCancel(); }
        holdArm(t);
      }
      if (Math.abs(t - last) < 0.0012) { return 1; }
      last = t;

      /* one number drives everything: the active stage, as a float */
      var p = smooth(remap(t, 0.26, 0.44))
            + smooth(remap(t, 0.50, 0.68))
            + smooth(remap(t, 0.74, 0.92));

      /* the conditions leave their row and stack into a column as the pyramid
         arrives, which is what makes room for the strip to grow */
      var vert = smooth(clamp01((p - 0.15) / 0.7));
      conditions(vert);
      var hw0 = lerp(HW[0], HW_COL, vert);

      /* on beat one there is nothing to the left yet, so the strip sits centred
         and slides right into its running position as the queue fills */
      var dx = lerp(NARROW ? -120 : -236, 0, smooth(clamp01(p / 1.25))) * (1 - holdK);

      /* the strip */
      var pos = [];
      for (var i = 0; i < E.stgs.length; i++) {
        var age = p - i, sl, op;
        if (age < 0) {                                  /* still waiting off-stage */
          var inK = clamp01(1 + age * 1.9);
          sl = { x: lerp(OFFSTAGE, SLOT[0].x, inK), s: lerp(0.7, 1, inK) };
          op = i === 0 ? clamp01((t - 0.02) / 0.06) : inK * inK;
        } else {
          sl = slotAt(age);
          op = 1;
        }
        /* the final hold pulls every stage onto one line at one scale */
        if (holdK > 0) {
          sl = { x: lerp(sl.x, SUMMARY[i].x, holdK), s: lerp(sl.s, SUMMARY[i].s, holdK) };
          op = Math.max(op, holdK);
        }
        pos[i] = { x: sl.x + dx, s: sl.s, hw: (i === 0 ? hw0 : HW[i]) };
        E.stgs[i].setAttribute('transform',
          'translate(' + (sl.x + dx).toFixed(1) + ',' + CY.toFixed(1) + ') scale(' + sl.s.toFixed(4) + ')');
        E.stgs[i].style.opacity = op.toFixed(3);

        var c = E.caps[i];
        c.setAttribute('x', (sl.x + dx).toFixed(1));
        c.setAttribute('y', (CY + (NARROW ? 168 : 186)).toFixed(1));
        var live = holdK > 0.5 ? true : (age >= -0.4 && age < 0.6);
        c.style.opacity = (holdK > 0.5 ? op
                          : NARROW ? (live ? op : 0)
                          : op * (age >= 0 ? 1 : op)).toFixed(3);
        c.classList.toggle('is-live', live);
      }
      /* an arrow sits in the GAP between two panels, measured every frame. */
      for (var j = 0; j < E.joins.length; j++) {
        var A = pos[j], B = pos[j + 1];
        var gapL = A.x + A.hw * A.s, gapR = B.x - B.hw * B.s, gap = gapR - gapL;
        E.joins[j].setAttribute('transform', 'translate(' + ((gapL + gapR) / 2).toFixed(1) + ',' + CY + ')');
        E.joins[j].style.opacity =
          (Math.max(clamp01((p - (j + 0.7)) * 1.8), holdK) * clamp01((gap - 22) / 24)).toFixed(3);
      }

      /* the era marker, and the three conditions that change under it */
      E.era.style.opacity = clamp01((t - 0.02) / 0.06).toFixed(3);
      var after = p >= 1.62;
      if (after !== isAfter) {
        isAfter = after;
        E.era.classList.toggle('is-after', after);
        E.eraLab.textContent = after ? 'AFTER AI' : 'BEFORE AI';
      }
      for (var m = 1; m < 4; m++) {
        var on = p >= 1.62 + (m - 1) * 0.05 ? 1 : 0;
        if (on !== moved[m]) {
          moved[m] = on;
          E.c4[m].classList.toggle('is-moved', !!on);
          $('.c4-v', E.c4[m]).textContent = on ? AFTER[m] : BEFORE[m];
        }
      }
      E.legend.style.opacity = clamp01((p - 1.7) * 1.6).toFixed(3);

      /* 03 opens with its tasks still in a pyramid and spreads them into rows */
      var kd = clamp01((p - 1.12) / 0.82);
      /* 04 opens with them still in rows and gathers them into the new shape */
      var kr = clamp01((p - 2.12) / 0.82);
      for (var q2 = 0; q2 < defs.length; q2++) {
        var d = defs[q2];
        var lag = 0.1 * (d.layer / (L - 1));
        var a1 = smooth(clamp01((kd - lag) / (1 - lag * 0.9)));
        var a2 = smooth(clamp01((kr - lag) / (1 - lag * 0.9)));
        place(d.dec, d, lerp(d.px, d.rx, a1), lerp(d.py, d.ry, a1), clamp01((a1 - 0.5) / 0.4));
        place(d.rec, d, lerp(d.rx, d.ex, a2), lerp(d.ry, d.ey, a2), 1);
      }

      if (fill) { fill.style.width = (t * 100).toFixed(1) + '%'; }

      var bi = 0;
      for (var w = 0; w < PARTS.length; w++) { if (t >= PARTS[w].at) { bi = w; } }
      setBeat(bi);
      return 1;
    }

    return {
      paint: paint, parts: PARTS, viz: viz,
      relens: function () { NARROW = lens(); last = -1; },
      holdNow: function () { holdK = 1; last = -1; }
    };
  })();

  if (!TURN) { return; }

  /* ── the stepper ──────────────────────────────────────────────────────────
     The section is one viewport tall. Rather than scrubbing the animation with
     scroll position, four settled stages are advanced by discrete gestures:
       stage 0  conditions (four circles in a row)
       stage 1  the circles stack into a column and the pyramid forms
       stage 2  + the pyramid decomposes into tasks
       stage 3  + the tasks recompose into the new shape
     Each of these is a fixed point on the underlying TURN timeline; a step
     tweens between them so all the motion happens in-between. Three steps carry
     the reader across all four stages. While the section fills the viewport the
     page scroll is captured (one gesture = one step); stepping past either end
     releases it so the rest of the page scrolls normally. ── */
  var STAGE_T = [0.08, 0.47, 0.70, 0.93]; /* underlying-timeline value per stage */
  var LAST = STAGE_T.length - 1;
  var DUR = 850;
  var step = 0, curT = STAGE_T[0];
  TURN.paint(curT);

  /* engaged: the section is capturing scroll. tween: a transition is playing
     (blocks input). One physical gesture = exactly one action (arrival, step,
     or release). A wheel event counts as the start of a NEW gesture when
     either (a) >GAP ms passed since the previous wheel — a clean flick — or
     (b) the delta magnitudes are RISING again after decaying (newGesture());
     that is how a deliberate flick shows up inside trackpad momentum, which
     never leaves a time gap. A long or steady scroll only ever decays, so it
     can never fire twice — scrolling harder/longer still moves ONE stage. */
  var engaged = false, exitLock = 0, tween = false;
  var lastWheel = 0;
  var GAP = 250;

  var wDeltas = [];
  function newGesture(now, delta) {
    var fresh = (now - lastWheel) > GAP;
    var d = Math.abs(delta);
    wDeltas.push(d);
    if (wDeltas.length > 120) { wDeltas.shift(); }
    if (fresh) { return true; }
    /* rising-energy check: mean of the newest few clearly above the mean of
       the stretch before them means a fresh push, not a decaying tail. */
    var n = wDeltas.length;
    if (n < 16) { return false; }
    var i, endAvg = 0, prevAvg = 0;
    for (i = n - 6; i < n; i++) { endAvg += wDeltas[i]; }
    endAvg /= 6;
    var lo = Math.max(0, n - 46);
    for (i = lo; i < n - 6; i++) { prevAvg += wDeltas[i]; }
    prevAvg /= (n - 6 - lo);
    return endAvg > prevAvg * 1.7 && endAvg > 6;
  }
  /* every action consumes the current gesture: reset the energy baseline */
  function consume() { wDeltas.length = 0; }

  function ease(x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }

  function paintTo(target) {
    if (reduce) { curT = target; TURN.paint(curT); tween = false; return; }
    var from = curT, t0 = performance.now();
    tween = true;
    (function frameStep(now) {
      var k = Math.min(1, (now - t0) / DUR);
      curT = from + (target - from) * ease(k);
      TURN.paint(curT);
      if (k < 1) { requestAnimationFrame(frameStep); }
      else { curT = target; TURN.paint(curT); tween = false; }
    })(t0);
  }

  function goStep(n) {
    n = Math.max(0, Math.min(LAST, n));
    if (n === step) { return; }
    step = n;
    paintTo(STAGE_T[step]);
  }

  /* Alignment is owned by CSS scroll-snap (_chrome.scss: mandatory snap with
     every top-level section snap-aligned to start). When the reader's flick
     carries the page toward this section, the browser's own snap animation
     settles it flush with the viewport — while we capture all further wheel
     input. No JS scrolling here at all: an earlier version ran its own rAF
     align loop alongside the snap animation and the two fought over the
     scroll position, which read as jitter. */
  function alignTop() { /* the browser's scroll snap does this */ }

  /* housekeeping + engage detection. Returns 'pass' (not ours — page scrolls),
     'enter' (this call just engaged), or 'engaged' (already engaged). */
  function phase(dir, rect, vh) {
    /* the section drifted out from under us (e.g. an anchor jump): let go */
    if (engaged && (rect.top > vh * 0.5 || rect.bottom < vh * 0.5)) { engaged = false; }
    if (rect.bottom < vh * 0.4 || rect.top > vh * 0.6) { exitLock = 0; }
    if (engaged) { return 'engaged'; }
    var enterDown = dir > 0 && rect.top <= vh * 0.5 && rect.top > -vh * 0.5 && rect.bottom > vh * 0.6 && exitLock !== 1;
    var enterUp   = dir < 0 && rect.bottom >= vh * 0.5 && rect.bottom < vh * 1.5 && rect.top < vh * 0.4 && exitLock !== -1;
    return (enterDown || enterUp) ? 'enter' : 'pass';
  }

  function atEnd(dir) { return (dir > 0 && step >= LAST) || (dir < 0 && step <= 0); }

  function onWheel(e) {
    var now = performance.now();
    var dir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
    if (!dir) { return; }
    var act = newGesture(now, e.deltaY);          /* must run every event to
                                                     keep the energy baseline */
    lastWheel = now;

    var ph = phase(dir, root.getBoundingClientRect(), window.innerHeight);
    if (ph === 'pass') { return; }                /* page scrolls normally */
    if (ph === 'enter') {
      /* arrival IS this gesture's one action: snap the section into place and
         show its entry stage — stage 1 coming down, stage 4 coming up. The
         rest of the flick's momentum is captured and ignored. */
      engaged = true; consume(); alignTop();
      step = dir > 0 ? 0 : LAST;
      if (curT !== STAGE_T[step]) { paintTo(STAGE_T[step]); }
      e.preventDefault();
      return;
    }
    /* engaged */
    if (tween) { consume(); e.preventDefault(); return; }
    if (act && atEnd(dir)) {                       /* a NEW gesture past an end
                                                      releases the page */
      engaged = false; exitLock = dir > 0 ? 1 : -1; consume();
      return;                                      /* no preventDefault → scrolls */
    }
    e.preventDefault();                            /* capture: the page stays put */
    if (act) { consume(); goStep(step + dir); }
  }

  var touchY = null, touchDone = false;
  function onTouchStart(e) { touchY = e.touches[0].clientY; touchDone = false; }
  function onTouchMove(e) {
    if (touchY === null) { return; }
    var y = e.touches[0].clientY, dy = touchY - y;       /* >0 = swipe up = forward */
    var dir = dy > 0 ? 1 : (dy < 0 ? -1 : 0);
    if (!dir) { return; }
    var ph = phase(dir, root.getBoundingClientRect(), window.innerHeight);
    if (ph === 'pass') { return; }
    if (ph === 'enter') {
      engaged = true; alignTop(); touchDone = true;
      step = dir > 0 ? 0 : LAST;
      if (curT !== STAGE_T[step]) { paintTo(STAGE_T[step]); }
      e.preventDefault();
      return;
    }
    /* one swipe = one thing */
    if (!touchDone && !tween && Math.abs(dy) > 40 && atEnd(dir)) {
      engaged = false; exitLock = dir > 0 ? 1 : -1; touchDone = true;
      return;                                     /* release → page scrolls */
    }
    e.preventDefault();
    if (!touchDone && !tween && Math.abs(dy) > 40) { touchDone = true; goStep(step + dir); }
  }
  function onTouchEnd() { touchY = null; }

  function onKey(e) {
    var rect = root.getBoundingClientRect(), vh = window.innerHeight;
    if (rect.top > 2 || rect.bottom < vh - 2) { return; } /* only while it fills the viewport */
    if (tween) { return; }
    var fwd = e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ' || e.key === 'Spacebar';
    var back = e.key === 'ArrowUp' || e.key === 'PageUp';
    if (fwd && step < LAST) { e.preventDefault(); goStep(step + 1); }
    else if (back && step > 0) { e.preventDefault(); goStep(step - 1); }
    /* at the ends, the key falls through to the browser's own scroll */
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('touchstart', onTouchStart, { passive: true });
  window.addEventListener('touchmove', onTouchMove, { passive: false });
  window.addEventListener('touchend', onTouchEnd, { passive: true });
  window.addEventListener('keydown', onKey);

  var relensTimer;
  window.addEventListener('resize', function () {
    clearTimeout(relensTimer);
    relensTimer = setTimeout(function () { TURN.relens(); TURN.paint(curT); }, 150);
  });
})();
